export default __webpack_public_path__ + "static/media/removeIcon.ee69ef31.svg";